import React from 'react';
import './SplashScreen.css';

const SplashScreen = ({ fadeOut }) => {
  return (
    <div className={`splash-container ${fadeOut ? 'fade-out' : ''}`}>
      <div className="splash-content">
        <div className="logo-wrapper">
          <img 
            src="/assets/final_peoppoll_logo.png" 
            alt="Peopoll Logo" 
            className="splash-logo"
          />
        </div>
        <div className="spinner-wrapper">
          <div className="premium-spinner"></div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
